import { render, staticRenderFns } from "./presupuestoListList.vue?vue&type=template&id=4c5972d2"
import script from "./presupuestoListList.vue?vue&type=script&lang=js"
export * from "./presupuestoListList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports